import { useState, forwardRef } from 'react';
import Tippy from '@tippyjs/react';
import type { TippyProps } from '@tippyjs/react';

const LazyTippy = forwardRef<Element, TippyProps>(function LazyTippy(props, ref) {
  const [mounted, setMounted] = useState(false);

  const lazyPlugin = {
    fn: () => ({
      onMount: () => setMounted(true),
      onHidden: () => setMounted(false),
    }),
  };

  const computedProps: TippyProps = { ...props };

  computedProps.plugins = [lazyPlugin, ...(props.plugins || [])];

  const render = props.render;
  if (render) {
    computedProps.render = (...args: Parameters<NonNullable<TippyProps['render']>>) => (mounted ? render(...args) : '');
  } else {
    computedProps.content = mounted ? props.content : '';
  }

  return <Tippy {...computedProps} ref={ref} />;
});

export default LazyTippy;
